import { Component, Input } from "@angular/core";
@Component({
    selector: 'steps-nominacion',
    templateUrl: './steps-nominacion.component.html',
    styleUrl: './steps-nominacion.component.scss'
})
export class StepsNominacion {
    @Input() step: number = 1;
}